import { flatten, compact, uniq } from 'lodash';
import { WithRouterProps } from 'react-router';

export function parseKeywords(
  location: WithRouterProps['location'],
  params: WithRouterProps['params'],
): string[] {
  return uniq(compact(flatten([
    location?.query?.query,
    location?.query?.make,
    params?.brand_slug,
  ])));
}
